/**
 * Check if input is a valid GUID/UUID
 * Supports both with and without curly braces
 */
export function isGUID(value: string): boolean {
  const regex = /^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/;
  return regex.test(value);
}
